<template>
  <div>
      <v-toolbar dense>
          <v-chip icon id="pagetitle" to="/perfscore">
              <v-icon left>mdi-arrow-left</v-icon>
              {{year}}年{{month}}月
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn color='primary' @click="save">
              <v-icon left>mdi-content-save</v-icon>
              保存
          </v-btn>
      </v-toolbar>
      <department-selector v-model="tab" :departments="departmentUserObjectiveRatings" show-count show-done />
      <v-tabs-items v-model="tab">
          <v-tab-item v-for="dep in departmentUserObjectiveRatings" :key="dep.departmentid">
            <objective-card v-model="dep.userObjectives" :mode="1" :sequencenum="sequencenum">
            </objective-card>
          </v-tab-item>
      </v-tabs-items>
      <v-dialog
        v-model="msgdialog"
        width="500"
      >
        <v-card :color="msgcolor">
          <v-card-title>
            提示
          </v-card-title>
          <v-card-text class="white--text">
            <v-icon>mdi-alert-box-outline</v-icon>
            {{msg}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            :color="msgcolor"
            @click="msgdialog = false"
            class="text-caption"
          >
            确定
          </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import ObjectiveCard from './ObjectiveCard.vue'
import DepartmentSelector from './DepartmentSelector.vue'
import { mapState } from 'vuex'
import { sortDepartmentsByName } from '@/utils/departmentsort.js'

export default {
    name: 'PrefScorePage',
    props:{
        year:{type:Number}, month:{type:Number}
    },
    components: {
        ObjectiveCard,
        DepartmentSelector
    },
    data: () => ({
        departmentUserObjectiveRatings:[],
        service: null,
        tab:0,
        sequencenum:0,
        msg:'',
        msgdialog:false,
        msgcolor:'success'
    }),
    computed: {
        ...mapState(['myCurManageDepartment'])
    },
    watch: {
        'departmentUserObjectiveRatings': {
            deep: true,
            handler: function() {
                this.checkall()
            }
        }
    },
    created() {
        this.service = this.$store.getters.service('user-objective-rating')

        this.loadData()
    },
    methods: {
        async loadData() {

            const {data} = await this.service.find({
                query:{
                    year:this.year,
                    month:this.month,
                    'ratedepartments.id':this.myCurManageDepartment.departmentid,
                    customFind:{name:'groupUserObjectiveRatingByDepartment', 'departmentid':this.myCurManageDepartment.departmentid}
                }
            })

            //set needInputPoints flag and selectedCre to the item.
            data.forEach(duobjs => duobjs.userObjectives.forEach(uobjs => uobjs.objectives.forEach(obj => obj.items.forEach(item => {
                item.needInputPoints = item.creteria && (item.creteria.length == 1 
                    || item.creteria.some(cr => cr.points === undefined 
                                                                    || cr.points === null
                                                                    || cr.min !== undefined || cr.max !== undefined
                                                                    || cr.isPercent))

                const myratedepartment = item.ratedepartments.find(rd => rd.id === this.myCurManageDepartment.departmentid
                    && rd.creteriaid)
                if (myratedepartment) {//existing rating
                    item.selectedCre = item.creteria.find(cr => cr._id === myratedepartment.creteriaid)
                    item.selectedCre.points = myratedepartment.points
                    item.selectedCre.comment = myratedepartment.comment
                    item.selectedCre.old = true
                }
            }))))

            const me = this
            data.forEach(duo => me.check4done(duo))
            this.departmentUserObjectiveRatings = sortDepartmentsByName(data)
            this.sequencenum++
        },

        check4done(userobjectivesratings) {
            
            const me = this
            userobjectivesratings.done = userobjectivesratings.userObjectives.reduce((uo_res, uo) => {
                uo.done = uo.objectives.reduce((obj_res, obj) => 
                    {
                        obj.done = obj.items.reduce((item_res, item) => {
                            if (item.selectedCre) {
                                const myratedepartment = item.ratedepartments.find(rd => rd.id === me.myCurManageDepartment.departmentid)
                                if (myratedepartment) {
                                    myratedepartment.creteriaid = item.selectedCre._id
                                    myratedepartment.points = item.selectedCre.points != undefined ? item.selectedCre.points:item.selectedCre.min
                                    myratedepartment.comment = item.selectedCre.comment
                                } else {
                                    item.ratedepartments.push({
                                        id: me.myCurManageDepartment.departmentid,
                                        name: me.myCurManageDepartment.departmentname,
                                        creteriaid: item.selectedCre._id,
                                        points: item.selectedCre.points != undefined ? item.selectedCre.points:item.selectedCre.min,
                                        comment: item.selectedCre.comment
                                    })
                                }
                            }
                            item.done = item.ratedepartments.some(rd => rd.id === me.myCurManageDepartment.departmentid && rd.creteriaid)
                            return item_res && item.done
                        }, true)
                        return obj_res && obj.done
                    }, true)

                const myrd1 = uo.ratedepartments.find(rd => rd.id === me.myCurManageDepartment.departmentid)
                if (myrd1) {
                    myrd1.done = uo.done
                }
                return uo_res && uo.done
            }, true)

            console.log(`check4done: ${JSON.stringify(userobjectivesratings)}`)
        },

        checkall() {
            console.log(`perf score checkall...`)
            const me = this
            this.departmentUserObjectiveRatings.forEach(duo => me.check4done(duo))
        },

        async save() {
            let uobjectives2save = []
            
            this.checkall()

            this.departmentUserObjectiveRatings.forEach(duo => {
                uobjectives2save = uobjectives2save.concat(duo.userObjectives.filter(
                    uo => uo.objectives.some(obj => obj.items.some(item => 
                        item.selectedCre && !item.selectedCre.old
                    ))))
            })

            console.log(`save:`)
            uobjectives2save.forEach(uo => {
                console.log(`username: ${uo.username}`)
            });

            try {
                await this.service.patch(null, uobjectives2save, {query:{customPatch:{name:'merge', 
                    departmentid:this.myCurManageDepartment.departmentid,
                    year:this.year, month:this.month}}})
                this.showMsg('保存成功!')
            } catch (e) {
                this.showMsg(e.message, true)
            }
        },
        showMsg(msg, error = false) {
            this.msg = msg
            this.msgcolor = error ? 'error':'success'
            this.msgdialog = true
        },
    }
}
</script>

<style>
    .v-expansion-panel-content__wrap {
        padding-right:0 !important;
    }
</style>